export default "__VITE_ASSET__DYJgb3rC__"